<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderClientSlim :project="project" />
      </slot>
    </template>

    <AttachmentsPrintGrid
      :attachments="project.dongleSerialNumberAttachments"
      fieldName="dongleSerialNumberAttachments"
      :maxImages="2"
    />

    <AttachmentsPrintGrid
      :attachments="project.inverterAttachments"
      fieldName="inverterAttachments"
      :maxImages="2"
    />

    <AttachmentsPrintGrid
      :attachments="project.variousBreakthroughsWithPossibleSealingsAttachments"
      fieldName="variousBreakthroughsWithPossibleSealingsAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderClientSlim from '@/components/Print/PrintHeaderClientSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderClientSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
